"use client";
/*
 * Documentation:
 * DC_Text_Callout — https://app.subframe.com/4f62853ee923/library?component=DC_Text_Callout_fe220683-7c55-4f93-be9b-b4c81f6f5858
 */

import React from "react";
import { FeatherAlertTriangle } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface Dc_Text_CalloutRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  text?: React.ReactNode;
  className?: string;
}

const Dc_Text_CalloutRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Text_CalloutRootProps
>(function Dc_Text_CalloutRoot(
  {
    icon = <FeatherAlertTriangle />,
    text,
    className,
    ...otherProps
  }: Dc_Text_CalloutRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full items-start gap-6 rounded-md bg-neutral-50 px-6 py-6",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {icon ? (
        <SubframeCore.IconWrapper className="text-heading-3 font-heading-3 text-default-font">
          {icon}
        </SubframeCore.IconWrapper>
      ) : null}
      {text ? (
        <span className="text-body font-body text-default-font">{text}</span>
      ) : null}
    </div>
  );
});

export const Dc_Text_Callout = Dc_Text_CalloutRoot;
